import { LockClosedIcon, ShieldCheckIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

const complianceItems = [
  {
    name: 'SOC 2',
    description: 'Enterprise-grade security',
    icon: ShieldCheckIcon,
  },
  {
    name: 'ISO 27001',
    description: 'Information Security',
    icon: LockClosedIcon,
  },
  {
    name: 'HIPAA',
    description: 'Healthcare Compliant',
    icon: ShieldCheckIcon,
  },
];

export default function SecurityCompliance() {
  const { t } = useLocale('ai-transcription');

  return (
    <div className='bg-white py-24 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Secure and Confidential')}
          </h2>
          <p className='mt-6 text-lg leading-8 text-gray-500 dark:text-slate-400'>
            {t(
              'Your audio transcripts are safeguarded with industry-leading security measures to ensure confidentiality and data protection.',
            )}
          </p>
        </div>

        <div className='mx-auto mt-16 max-w-5xl'>
          <div className='grid grid-cols-1 gap-8 sm:grid-cols-3'>
            {complianceItems.map((item) => (
              <div
                key={item.name}
                className='flex flex-col items-center rounded-2xl bg-gray-50 p-8 text-center dark:bg-slate-800'
              >
                <div className='mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30'>
                  <item.icon
                    className='h-8 w-8 text-green-600 dark:text-green-400'
                    aria-hidden='true'
                  />
                </div>
                <h3 className='text-xl font-semibold text-gray-900 dark:text-slate-200'>
                  {t(item.name)}
                </h3>
                <p className='mt-2 text-sm text-gray-500 dark:text-slate-400'>
                  {t(item.description)}
                </p>
              </div>
            ))}
          </div>

          <div className='mt-16 rounded-2xl bg-gradient-to-r from-primary-50 to-pink-50 p-8 dark:from-primary-900/20 dark:to-pink-900/20'>
            <div className='text-center'>
              <LockClosedIcon
                className='mx-auto h-12 w-12 text-primary-600 dark:text-primary-400'
                aria-hidden='true'
              />
              <h3 className='mt-4 text-xl font-semibold text-gray-900 dark:text-slate-200'>
                {t('Data Protection Guarantee')}
              </h3>
              <p className='mt-4 text-base text-gray-600 dark:text-slate-300'>
                {t(
                  'We securely process your files, never share them with third parties, and allow you to delete files after usage, ensuring your data remains confidential and protected.',
                )}
              </p>
              <div className='mt-6 flex flex-wrap justify-center gap-4 text-sm text-gray-500 dark:text-slate-400'>
                <span className='flex items-center'>
                  <span className='mr-2 h-2 w-2 rounded-full bg-green-500'></span>
                  {t('End-to-end encryption')}
                </span>
                <span className='flex items-center'>
                  <span className='mr-2 h-2 w-2 rounded-full bg-green-500'></span>
                  {t('Automatic file deletion')}
                </span>
                <span className='flex items-center'>
                  <span className='mr-2 h-2 w-2 rounded-full bg-green-500'></span>
                  {t('No third-party sharing')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
